<template>
  <div
    v-if="tripDetails && Object.keys(tripDetails).length > 0"
    class="app-layout-trip overflow-hidden"
  >
    <div class="px-2 py-3 app-layout-trip-map">
      <v-card elevation="0" class="pa-3 mb-3">
        <v-row v-if="tripDetails && tripDetails.trip_details">
          <v-col cols="8" class="d-flex align-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <h2
                  class="mr-2 text-capitalize"
                  v-if="tripDetails.trip_details.reference_number"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ tripDetails.trip_details.reference_number }}
                </h2>
              </template>
              <span class="text-capitalize">reference number</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  class="mr-1 text-capitalize white--text font-weight-bold"
                  x-small
                  :class="
                    $helper.tripStatusColor(tripDetails.status.toLowerCase())
                  "
                  v-if="tripDetails.status"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ tripDetails.status }}
                </v-chip>
              </template>
              <span class="text-capitalize">{{
                statusMapping.tripStatus
              }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="4" class="text-right d-flex justify-end align-center">
            <div class="mr-4" v-if="tripDetails.trip_details.trip_date">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <h5
                    v-bind="attrs"
                    v-on="on"
                    class="mr-2 text-capitalize"
                    v-if="tripDetails.trip_details.trip_date"
                  >
                    {{ tripDetails.trip_details.trip_date }}
                  </h5>
                </template>
                <span>Trip Date</span>
              </v-tooltip>
            </div>

            <div
              class=""
              v-if="
                tripDetails &&
                tripDetails.trip_details &&
                tripDetails.trip_details.branch
              "
            >
              <v-chip dense class="primary" outlined>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <h5
                      v-bind="attrs"
                      v-on="on"
                      class="text-capitalize text-center"
                      v-if="tripDetails.trip_details.branch"
                    >
                      {{ tripDetails.trip_details.branch }}
                    </h5>
                  </template>
                  <span>Branch Name</span>
                </v-tooltip>
              </v-chip>
            </div>
          </v-col>
        </v-row>

        <div v-if="tripDetails && tripDetails.id" class="pl-2 text-right">
          <PrimaryButton
            id="tripEdit"
            small
            v-show="
              tripDetails.type == orderSegment.SALES &&
              (tripDetails.status == 'loading' ||
                tripDetails.status == 'scheduled' ||
                tripDetails.status == 'unallocated')
            "
            v-if="
              permissions &&
              permissions.change &&
              tripDetails &&
              tripDetails.action_details &&
              tripDetails.action_details.is_editable
            "
            @click="
              $router.push({
                name: 'edit-trip',
                params: { id: tripDetails.id },
              })
            "
            name="edit"
            btnClass="ma-1 rounded-lg"
            icon="mdi-pencil"
            tooltipTitle="edit trip"
          />
          <PrimaryButton
            id="adhocTripEdit"
            small
            v-show="
              tripDetails.type == orderSegment.ADHOC &&
              (tripDetails.status == 'loading' ||
                tripDetails.status == 'scheduled' ||
                tripDetails.status == 'unallocated')
            "
            v-if="
              permissions &&
              permissions.change &&
              tripDetails &&
              tripDetails.action_details &&
              tripDetails.action_details.is_editable
            "
            @click="
              $router.push({
                name: 'edit-adhoc-trip',
                params: { id: tripDetails.id },
              })
            "
            name="edit"
            btnClass="ma-1 rounded-lg"
            icon="mdi-pencil"
            tooltipTitle="edit trip"
          />
          <PrimaryButton
            id="assignPickupOrders"
            small
            v-show="tripDetails.type == orderSegment.SALES"
            v-if="
              permissions &&
              permissions.change &&
              tripDetails &&
              tripDetails.action_details &&
              tripDetails.action_details.can_assign_pickup_order
            "
            name="Assign Pickup Type Order"
            btnClass="ma-1 rounded-lg"
            icon="mdi-playlist-plus"
            tooltipTitle="Assign Pickup Type Order"
            @click="openPickupTypeOrderAssignForm = true"
          >
          </PrimaryButton>

          <PrimaryButton
            id="tripComplete"
            small
            v-show="
              tripDetails.status != 'completed' &&
              tripDetails.status != 'cancelled'
            "
            v-if="
              permissions &&
              permissions.change &&
              tripDetails &&
              tripDetails.action_details &&
              tripDetails.action_details.is_mark_as_completeable
            "
            @click="
              $router.push({
                name: 'mark-trip-as-complete',
                params: { id: tripDetails.id },
              })
            "
            :name="`Complete ${tripModule.trip}`"
            btnClass="ma-1 rounded-lg"
            icon="mdi-check"
            tooltipTitle="Trip Complete"
          />

          <PrimaryButton
            id="tripChangeAssets"
            small
            v-if="
              permissions &&
              permissions.change &&
              tripDetails &&
              tripDetails.action_details &&
              tripDetails.action_details.is_asset_changeable
            "
            v-show="
              tripDetails.status == 'scheduled' ||
              tripDetails.status == 'unallocated'
            "
            @click="openAssetChangeForm = true"
            name="Change Assets"
            btnClass="ma-1 rounded-lg"
            icon="mdi-toy-brick-marker"
            tooltipTitle="Trip Asset Change"
          >
          </PrimaryButton>
          <PrimaryButton
            id="tripReschedule"
            small
            v-if="
              permissions &&
              permissions.change &&
              tripDetails &&
              tripDetails.action_details &&
              tripDetails.action_details.is_reschedulable
            "
            @click="rescheduleTrip"
            name="Reschedule"
            btnClass="ma-1 rounded-lg"
            icon="mdi-sync"
            tooltipTitle="Trip Reschedule"
          >
          </PrimaryButton>

          <PrimaryButton
            id="tripLoadSheet"
            small
            v-if="
              permissions &&
              permissions.change &&
              tripDetails &&
              tripDetails.action_details &&
              tripDetails.action_details.is_load_sheet
            "
            @click="getTripSheet"
            name="Load Sheet"
            btnClass="ma-1 rounded-lg"
            icon="mdi-file-pdf-box"
            tooltipTitle="Load Sheet"
          >
          </PrimaryButton>

          <PrimaryButton
            id="tripExpenses"
            small
            v-if="permissions && permissions.change"
            name="Expenses"
            btnClass="ma-1 rounded-lg"
            icon="mdi-currency-usd"
            tooltipTitle="Trip Expenses"
            @click="openTripExpense"
            v-show="tripDetails.status == 'completed'"
          >
          </PrimaryButton>

          <PrimaryButton
            id="tripOrderSummary"
            small
            v-if="permissions && permissions.change"
            name="Orders Summary"
            btnClass="ma-1 rounded-lg"
            icon="mdi-archive"
            tooltipTitle="Orders Summary"
            @click="downloadTripOrderSummary"
            v-show="tripDetails.status == 'completed'"
          >
          </PrimaryButton>

          <PrimaryButton
            id="tripOrderSummary"
            small
            v-if="permissions && permissions.change"
            name="Stop locations"
            btnClass="ma-1 rounded-lg"
            icon="mdi-map-marker"
            tooltipTitle="Stop Locations"
            @click="fetchCustomerSequence"
          >
          </PrimaryButton>

          <PrimaryButton
            id="tripCancel"
            small
            v-if="
              permissions &&
              permissions.change &&
              tripDetails &&
              tripDetails.action_details &&
              tripDetails.action_details.is_cancellable
            "
            depressed
            @click="cancelTrip"
            name="Cancel"
            btnClass="error darken-5 ma-1 rounded-lg"
            icon="mdi-cancel"
            tooltipTitle="Trip Cancel"
          >
          </PrimaryButton>
        </div>
      </v-card>

      <v-row no-gutters class="pa-0">
        <v-col cols="12" lg="6" class="pr-lg-2">
          <TripDriverCard :detailsObj="tripDetails.asset_details.driver" />
        </v-col>
        <v-col cols="12" lg="6" class="pl-lg-2 py-4 py-lg-0">
          <TripVehicleCard :detailsObj="tripDetails.asset_details.vehicle" />
        </v-col>
      </v-row>
      <!-- 
        <div
          v-else
          class="h-100 w-100"
          style="display: flex; justify-content: center; align-items: center"
        >
          <h4 class="text-capitalize grey--text">
            There are no trips selected
          </h4>
        </div> -->

      <v-card elevation="0" class="mt-lg-4">
        <GoogleMap
          :hasMapInfo="true"
          mapHeight="calc(100vh - 520px)"
          mapWidth="100%"
          ref="tripMap"
          :clusterMarkers="true"
        >
          <template #mapInfo>
            <MapInfo
              legendType="trip"
              :actualRoute="actualRoute"
              :plannedRoute="plannedRoute"
              :referenceElement="$refs.tripMap"
            />
          </template>
          <template #action>
            <div>
              <v-btn
                :color="isPlayRoute ? 'error' : 'success lighten-1'"
                x-small
                class="btn-box mb-2"
                depressed
                @click="playRoute"
              >
                <v-icon color="white">
                  {{ isPlayRoute ? "mdi-stop" : "mdi-play" }}
                </v-icon>
              </v-btn>
            </div>
          </template>
        </GoogleMap>
      </v-card>

      <div elevation="0" class="mt-4">
        <v-row no-gutters class="d-flex h-100">
          <v-col
            cols="12"
            lg="6"
            class="pr-lg-2"
            v-if="tripDetails.item_details"
          >
            <CardTripItem
              :dataObj="tripDetails.item_details"
              :dataOrderObj="
                tripDetails &&
                tripDetails.order_details &&
                tripDetails.order_details.basic
                  ? tripDetails.order_details.basic
                  : {}
              "
            />
          </v-col>

          <v-col cols="12" lg="6" class="pl-lg-2 py-4 py-lg-0">
            <CardTripItemInfo
              v-if="
                tripDetails &&
                tripDetails.order_details &&
                tripDetails.order_details.basic
              "
              :dataObj="tripDetails.order_details.basic"
              :vehicleUtilizationPer="
                tripDetails &&
                tripDetails.asset_details &&
                tripDetails.asset_details.vehicle
                  ? tripDetails.asset_details.vehicle.tonnage_utilized
                  : 0
              "
              @orderList="getTripOrderDetails"
            />
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="pa-2">
      <v-card
        elevation="0"
        class="sticky-top mt-1 mb-2 pa-4 d-flex justify-space-between white rounded-lg"
      >
        <h5 class="text-subtitle-2">Details</h5>
        <div>
          <SecondaryButton
            id="tripOdometer"
            x-small
            class="mr-2 text-uppercase"
            :name="`${tripModule.trip} Odometer`"
            @click="isVisibleTripOdometer = !isVisibleTripOdometer"
            v-if="tripDetails.status == 'completed'"
          >
          </SecondaryButton>
          <SecondaryButton
            id="tripStatus"
            x-small
            class="mr-2 text-uppercase"
            :name="`${statusMapping.status}`"
            @click="isVisibleOrderStatus = !isVisibleOrderStatus"
          >
            {{ statusMapping.status }}
          </SecondaryButton>

          <SecondaryButton
            id="tripInfo"
            @click="isVisibleTripPlannedDetails = !isVisibleTripPlannedDetails"
            x-small
            class="mr-2 text-uppercase"
            :name="`${tripModule.trip} Info`"
          >
          </SecondaryButton>

          <SecondaryButton
            id="tripLogs"
            @click="isVisibleLogs = !isVisibleLogs"
            x-small
            class="text-uppercase font-weight-bolder"
            name="logs"
          >
            logs
          </SecondaryButton>
        </div>
      </v-card>

      <div
        class="app-layout-trip-details custom-medium-scroll pr-2 overflow-y-auto"
      >
        <!-- <v-card
          elevation="0"
          class="card-box-shadow px-4 py-2 w-100 mb-3"
          style="border-radius: 10px; overflow-y"
        >
          <v-row no-gutters>
            <v-col cols="12">
              <h2>AED 632.00</h2>
            </v-col>
            <v-col cols="12" class="mb-4">
              <h5 class="text-capitalize grey--text">
                payment collection
              </h5>
            </v-col>
            <v-col cols="6">
              <v-card
                elevation="0"
                style="border: 1px solid #80808026"
                class="d-flex pa-3 mr-2"
              >
                <v-btn
                  small
                  class="h-100 mr-3 primary--text"
                  depressed
                  style="min-width: 40px !important; width: 30px; height: 40px"
                >
                  <v-icon color="primary" small>mdi-cash</v-icon>
                </v-btn>
                <div class="mr-2">
                  <h4>$3403</h4>
                  <h5 class="text-capitalize grey--text">cash</h5>
                </div>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card
                elevation="0"
                style="border: 1px solid #80808026"
                class="d-flex pa-3"
              >
                <v-btn
                  small
                  class="h-100 mr-3 primary--text"
                  depressed
                  style="min-width: 40px !important; width: 30px; height: 40px"
                >
                  <v-icon color="primary" small>mdi-credit-card</v-icon>
                </v-btn>
                <div class="mr-2">
                  <h4>$3403</h4>
                  <h5 class="text-capitalize grey--text">credit</h5>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card> -->
        <v-expand-transition>
          <div v-show="isVisibleTripOdometer">
            <v-card
              elevation="0"
              v-if="
                tripDetails &&
                tripDetails.status == 'completed' &&
                tripDetails.trip_odometer
              "
              class="rounded-lg my-2 w-100"
              style=" overflow-y"
            >
              <v-card-title class="px-2 py-2 text-capitalize white">
                <h5 class="text-caption font-weight-bold">
                  Trip Odometer Reading
                </h5>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-subtitle>
                <v-row
                  no-gutters
                  class="py-1"
                  v-if="
                    tripDetails.trip_odometer &&
                    tripDetails.trip_odometer.trip_start
                  "
                >
                  <v-col cols="5">
                    <h5 class="text-left text-capitalize">Trip Start (KM)</h5>
                  </v-col>
                  <v-col cols="5">
                    <h6 class="text-caption black--text text-center">
                      {{ tripDetails.trip_odometer.trip_start.trip_start_km }}
                    </h6>
                  </v-col>
                  <v-icon
                    color="primary"
                    v-if="
                      tripDetails.trip_odometer.trip_start.trip_start_attachment
                    "
                    small
                    @click="
                      openAttachmentInNewTab(
                        tripDetails.trip_odometer.trip_start
                          .trip_start_attachment
                      )
                    "
                    >mdi-eye</v-icon
                  >
                </v-row>
                <v-row
                  no-gutters
                  class="py-1"
                  v-if="
                    tripDetails.trip_odometer &&
                    tripDetails.trip_odometer.trip_end
                  "
                >
                  <v-col cols="5">
                    <h5 class="text-left text-capitalize">Trip End (KM)</h5>
                  </v-col>
                  <v-col cols="5">
                    <h6 class="text-caption black--text text-center">
                      {{ tripDetails.trip_odometer.trip_end.trip_end_km }}
                    </h6>
                  </v-col>
                  <v-icon
                    color="primary"
                    v-if="
                      tripDetails.trip_odometer.trip_end.trip_end_attachment
                    "
                    small
                    @click="
                      openAttachmentInNewTab(
                        tripDetails.trip_odometer.trip_end.trip_end_attachment
                      )
                    "
                    >mdi-eye</v-icon
                  >
                </v-row>
              </v-card-subtitle>
            </v-card>
          </div>
        </v-expand-transition>
        <v-expand-transition>
          <div v-show="isVisibleOrderStatus">
            <v-card
              elevation="0"
              v-if="
                tripDetails &&
                tripDetails.order_details &&
                tripDetails.order_details.statistics
              "
              class="rounded-lg my-2 w-100"
              style=" overflow-y"
            >
              <v-card-title class="px-2 py-2 text-capitalize white">
                <h5 class="text-caption font-weight-bold">
                  {{ statusMapping.orderStatus }}
                </h5>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-subtitle>
                <v-row
                  no-gutters
                  v-for="(value, key, index) in tripDetails.order_details
                    .statistics"
                  :key="index"
                  class="py-1"
                >
                  <v-col cols="6">
                    <h5 class="text-left text-capitalize" v-if="key">
                      {{ key.replace(/_/g, " ") }}
                    </h5>
                  </v-col>
                  <v-col cols="6">
                    <h6 class="text-caption black--text text-center">
                      {{ value }}
                    </h6>
                  </v-col>
                </v-row>
              </v-card-subtitle>
            </v-card>
          </div>
        </v-expand-transition>

        <v-expand-transition>
          <div v-show="isVisibleTripPlannedDetails">
            <v-card
              elevation="0"
              v-if="tripDetails && tripDetails.extra_information"
              class="rounded-lg mt-4 w-100"
            >
              <v-card-title class="py-1 d-flex justify-space-between">
                <v-row no-gutters>
                  <v-col cols="4"></v-col>
                  <v-col cols="4">
                    <h5 class="text-caption text-center font-weight-bold">
                      Planned {{ tripModule.trip }}
                    </h5>
                  </v-col>
                  <v-col cols="4">
                    <h5 class="text-caption text-center font-weight-bold">
                      Actual {{ tripModule.trip }}
                    </h5>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-subtitle>
                <v-row
                  no-gutters
                  v-for="(value, key, index) in tripDetails.extra_information"
                  :key="index"
                  class="py-1"
                >
                  <v-col cols="4">
                    <h5 class="text-left text-capitalize" v-if="key">
                      {{ key.replace(/_/g, " ") }}
                    </h5>
                  </v-col>
                  <v-col cols="4">
                    <h6 class="text-caption black--text text-center">
                      {{ value.planned ? value.planned : "-" }}
                    </h6>
                  </v-col>
                  <v-col cols="4">
                    <h6 class="text-caption black--text text-center">
                      {{ value.actual ? value.actual : "-" }}
                    </h6>
                  </v-col>
                </v-row>
              </v-card-subtitle>
            </v-card>
          </div>
        </v-expand-transition>

        <v-expand-transition>
          <v-card
            elevation="0"
            v-show="isVisibleLogs"
            class="card-box-shadow pa-0 w-100 mt-4"
            style="border-radius: 10px"
          >
            <v-card-title class="px-3 py-2 text-capitalize sticky-top white">
              <h5 class="text-caption font-weight-bold">logs</h5>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-subtitle
              class="overflow-y-auto custom-small-scroll"
              style="max-height: 50vh"
            >
              <Logs :logs="logs" v-if="logs && logs.length > 0" />
              <div class="h-100" v-else>
                <h5 class="font-weight-bold app-text-grey text-center mt-16">
                  There is no log available
                </h5>
              </div>
            </v-card-subtitle>
          </v-card>
        </v-expand-transition>
      </div>
    </div>
    <div class="d-none">
      <TripOrderList
        v-model="openOrderListDialog"
        :currentTrip="tripOrdersDetails"
      />
      <AssetChangeForm
        v-model="openAssetChangeForm"
        :tripObj="tripDetails"
        @refreshDetails="
          getTripDetails(tripDetails.id);
          $emit('getList', true);
        "
      />
      <CancelTripForm
        :data="selectedCancelTrips"
        tripMethod="cancelTrips"
        tripModule="trip"
        v-model="openCancelTripDialog"
        @refreshList="
          getData(tripDetails.id);
          $emit('getList', true);
        "
      />
      <RescheduleTripForm
        :tripParentObj="tripDetails"
        tripMethod="rescheduleTrip"
        tripModule="trip"
        v-model="openRescheduleTripDialog"
        @refreshList="
          getData(tripDetails.id);
          $emit('getList', true);
        "
      >
      </RescheduleTripForm>
      <TripExpenses v-model="openTripExpensesDialog" :parentObj="tripDetails" />
      <PickupTypeOrderAssignForm
        v-model="openPickupTypeOrderAssignForm"
        :parentObj="tripDetails"
        @refreshDetailPage="
          getData(tripDetails.id);
          $emit('getList', true);
        "
      ></PickupTypeOrderAssignForm>
      <CustomerSequence v-model="showCustomerSequence" :tripId="tripId">
      </CustomerSequence>
    </div>
  </div>
  <div v-else class="d-flex pt-4">
    <GoogleMap
      :hasMapInfo="false"
      mapHeight="90vh"
      style="width: 100%"
      ref="tripMapNew"
    />
  </div>
</template>

<script>
import { downloadBlob } from "@/utils/functions";

import { bus } from "@/main";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import Logs from "@/components/BaseComponents/Logs.vue";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";
import TripOrderList from "@/components/ModuleBasedComponents/Trip/TripOrdersList.vue";
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
import AssetChangeForm from "./AssetChangeForm.vue";
import CustomerSequence from "./CustomerSequence.vue";
import {
  tripModule,
  orderModule,
  statusMapping,
  itemModule,
} from "@/utils/moduleMapping";
import CancelTripForm from "./CancelTripForm.vue";
import RescheduleTripForm from "./RescheduleTripForm.vue";
import TripDriverCard from "@/components/ModuleBasedComponents/Trip/TripDriverCard.vue";
import TripVehicleCard from "@/components/ModuleBasedComponents/Trip/TripVehicleCard.vue";
import CardTripItemInfo from "@/components/ModuleBasedComponents/Trip/CardTripItemInfo.vue";
import CardTripItem from "@/components/ModuleBasedComponents/Trip/CardTripItem.vue";
import { orderSegment } from "@/utils/fieldConstants";
import TripExpenses from "@/components/ModuleBasedComponents/Trip/TripExpenses.vue";
import PickupTypeOrderAssignForm from "./PickupTypeOrderAssignForm.vue";

export default {
  components: {
    Logs,
    GoogleMap,
    MapInfo,
    TripOrderList,
    TripTooltipWithIcon,
    CustomerSequence,
    AssetChangeForm,
    CancelTripForm,
    RescheduleTripForm,
    TripDriverCard,
    TripVehicleCard,
    CardTripItemInfo,
    CardTripItem,
    TripExpenses,
    PickupTypeOrderAssignForm,
  },
  data() {
    return {
      tripId: null,
      showCustomerSequence: false,
      orderSegment,
      statusMapping,
      orderModule,
      itemModule,
      tripDetails: {},
      routeDetails: {},
      clearableRoute: false,
      logs: [],
      permissions: null,
      tripOrdersDetails: {},
      openOrderListDialog: false,
      openAssetChangeForm: false,
      openPickupTypeOrderAssignForm: false,

      tripModule,
      selectedCancelTrips: [],
      openCancelTripDialog: false,
      openRescheduleTripDialog: false,
      isVisibleRemarks: false,
      plannedRoute: null,
      actualRoute: null,
      isVisibleOrderStatus: true,
      isVisibleTripOdometer: true,
      isVisibleTripPlannedDetails: true,
      isVisibleLogs: true,
      openTripExpensesDialog: false,
      openTiaRecommendationDialog: false,
      index: 0,
      isPlayRoute: false,
    };
  },
  methods: {
    downloadTripOrderSummary() {
      bus.$emit("showLoader", true);
      this.$api.trip
        .getTripOrderSummary(this.tripDetails.id)
        .then((res) => {
          downloadBlob(res.data, `Trip Order Summary`, ".xlsx");
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          if (err.data) {
            this.formErrors = err.data;
          }
          bus.$emit("showLoader", false);
        });
    },
    fetchCustomerSequence() {
     
      this.showCustomerSequence = true;
      this.tripId = this.tripDetails.id;
     
    },
    openAttachmentInNewTab(url) {
      if (typeof window !== "undefined" && window.open) {
        window.open(url, "_blank");
      } else {
        // Handle the case where the window object or window.open method is not available
        console.error("Error: Cannot open URL in a new tab.");
      }
    },
    openTripExpense() {
      this.openTripExpensesDialog = true;
    },
    tiaRecommendation(val) {
      this.openTiaRecommendationDialog = true;
    },
    cancelTrip() {
      this.selectedCancelTrips = [this.tripDetails.id];
      this.openCancelTripDialog = true;
    },
    rescheduleTrip() {
      this.openRescheduleTripDialog = true;
    },
    showRemarks() {
      this.isVisibleRemarks = !this.isVisibleRemarks;
    },
    getTripSheet() {
      bus.$emit("showLoader", true);
      this.$api.trip
        .getTripSheetData(this.tripDetails.id)
        .then((res) => {
          bus.$emit("showLoader", false);
          let generatedPDFBlob = new Blob([res.data], {
            type: "application/pdf",
          });
          var pdfUrl = URL.createObjectURL(generatedPDFBlob);
          window.open(pdfUrl);
        })
        .catch((error) => {
          bus.$emit("showLoader", false);
          
          console.error(error);
        });
    },
    getData(id) {
      this.getTripDetails(id);
      this.getTripLog(id);
      this.getTripRoute(id);
    },
    playRoute() {
      let timer = setInterval(() => {
        if (this.$refs.tripMap) {
          clearInterval(timer);
          this.$refs.tripMap.clearGeoJson();
          this.$refs.tripMap.clearMarker();
          this.$refs.tripMap.removeAll();
          this.isPlayRoute = !this.isPlayRoute;

          if (
            this.routeDetails &&
            this.routeDetails.planned_route &&
            this.routeDetails.planned_route.pointers &&
            this.routeDetails.planned_route.route &&
            this.routeDetails.planned_route.route.features
          ) {
            if (this.isPlayRoute) {
              this.$refs.tripMap.setDroppingLocation(
                this.routeDetails.planned_route.pointers
              );
              this.$refs.tripMap.setMoveableMarker(
                this.routeDetails.planned_route.route.features
              );
            } else {
              this.$refs.tripMap.setPlannedRoute(
                this.routeDetails.planned_route
              );
              this.$refs.tripMap.setLocation(
                this.routeDetails.driver_last_location,
                "driver_live_location"
              );
            }
          }
        }
      }, 100);
    },
    getTripRoute(id) {
      bus.$emit("showLoader", true);
      this.$api.trip
        .getTripRoute(id)
        .then((res) => {
          let timer = setTimeout(() => {
            if (this.$refs.tripMap) {
              this.$refs.tripMap.clearGeoJson();
              this.$refs.tripMap.clearMarker();
              this.$refs.tripMap.removeAll();
              this.$refs.tripMap.clearDriverRoute();
              this.isPlayRoute = false;

              this.routeDetails = {};
              this.routeDetails = res.data;

              this.$refs.tripMap.setPlannedRoute(
                this.routeDetails.planned_route
              );
              this.$refs.tripMap.setLocation(
                this.routeDetails.driver_last_location,
                "driver_live_location"
              );
              this.plannedRoute = res?.data?.planned_route;

              setTimeout(() => {
                if (
                  this.routeDetails &&
                  this.routeDetails.actual_route &&
                  this.routeDetails.actual_route.features &&
                  this.routeDetails.actual_route.features.length != 0 &&
                  this.routeDetails.actual_route.features[0].geometry &&
                  this.routeDetails.actual_route.features[0].geometry
                    .coordinates
                ) {
                  this.actualRoute =
                    this.routeDetails.actual_route.features[0].geometry.coordinates;
                  this.$refs.tripMap.setDriverRoute(this.actualRoute);
                  this.clearableRoute = true;
                }
              }, 50);
            }
          }, 400);

          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getTripLog(id) {
      this.$api.logs
        .getTripLogs({ trip: id, limit: "all" })
        .then((res) => {
          this.logs = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getTripDetails(id) {
      bus.$emit("showLoader", true);
      this.$api.trip
        .getTripDetails(id)
        .then(({ data }) => {
          this.tripDetails = data;

          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getTripOrderDetails() {
      this.$api.orderNew
        .getOrderList({
          trip: this.tripDetails.id,
          limit: "all",
          is_duplicate: true,
        })
        .then((res) => {
          this.tripOrdersDetails = {
            orders: res.data,
            tripStatus: this.tripDetails.status,
          };
          this.openOrderListDialog = true;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  created() {
    this.permissions = this.$permissions.getPermission("trip");
  },
};
</script>

<style scoped>
.app-layout-trip {
  display: grid;
  grid-template-columns: 1fr 370px;
  height: 100%;
}

.app-layout-trip-map {
  /* display: grid; */
  /* grid-auto-rows: 200px 1fr 180px; */
  row-gap: 17px;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 65px);
}

.app-layout-trip-details {
  height: calc(100vh - 155px);
}
</style>
